import { render, staticRenderFns } from "./PrivacyVoodoo.vue?vue&type=template&id=201888b6&scoped=true"
import script from "./PrivacyVoodoo.vue?vue&type=script&lang=js"
export * from "./PrivacyVoodoo.vue?vue&type=script&lang=js"
import style0 from "./PrivacyVoodoo.vue?vue&type=style&index=0&id=201888b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201888b6",
  null
  
)

export default component.exports